//
//
//
//
//
//

export default {
    name: 'UiScrollContainer',
};
